import Vue from 'vue'
import Vuex from 'vuex'
import createPersiste from 'vue-savedata'
import * as actions from './actions'
import { UPDATE_SALESMAN_LIST, SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './actionTypes';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    imgDomain: 'https://cdn.gymoo.cn/', // 图片域名地址
    bucket_domain_token: '', //七牛上传token
    article_class: [], //文章分类
    article_label: [], //文章标签
    case_class: [], //案例行业分类
  },
  mutations: {
    [SET_BUCKET_DOMAIN](state, payload) {
      state.imgDomain = payload;
    },
    [SET_BUCKET_DOMAIN_TOKEN](state, payload) {
      state.bucket_domain_token = payload;
    },
    update_article_class(state, payload) {
      state.article_class = payload
    },
    update_article_label(state, payload) {
      state.article_label = payload
    },
    update_case_class(state, payload) {
      state.case_class = payload
    }
  },
  actions,
  plugins: [createPersiste()]
})

export default store;